export default __webpack_public_path__ + "static/media/baby-food.e262d5f6.png";